import type { Rubric } from '../types';

/**
 * The fixed grading rubric. The AI scores each criterion 1-5; the FINAL score is
 * computed in code (see scoringService.ts) using these weights. Weights sum to 1.
 */
export const RUBRIC_V1: Rubric = {
  version: 'dental-interview-v1.0',
  criteria: [
    { key: 'directness', label: 'Directness', weight: 0.1, meaning: 'Actually answers the question asked.' },
    { key: 'structure', label: 'Structure', weight: 0.15, meaning: 'Clear beginning, middle, and end.' },
    { key: 'specificity', label: 'Specificity', weight: 0.15, meaning: 'Uses concrete, personal examples.' },
    { key: 'dentalMotivation', label: 'Dental Motivation', weight: 0.2, meaning: 'Shows a mature understanding of dentistry.' },
    { key: 'professionalism', label: 'Professionalism', weight: 0.1, meaning: 'Mature, ethical, patient-centered.' },
    { key: 'reflection', label: 'Reflection', weight: 0.1, meaning: 'Explains what was learned.' },
    { key: 'schoolFit', label: 'School Fit', weight: 0.1, meaning: 'Connects the answer to the program.' },
    { key: 'communication', label: 'Communication', weight: 0.1, meaning: 'Clear, concise, confident delivery.' },
  ],
};

export const RUBRICS: Record<string, Rubric> = {
  [RUBRIC_V1.version]: RUBRIC_V1,
};

export function getRubric(version: string): Rubric {
  return RUBRICS[version] ?? RUBRIC_V1;
}

export const RUBRIC_CRITERIA_KEYS = RUBRIC_V1.criteria.map((c) => c.key);
